import { FinancialProductType, ProductStatus } from 'generated/graphql';

export const PRODUCT_STATUSES: Record<ProductStatus, string> = {
  [ProductStatus.Active]: 'aktívny',
  [ProductStatus.Archived]: 'archivovaný',
  [ProductStatus.Cancelled]: 'zrušený',
  [ProductStatus.Deleted]: 'zmazaný',
  [ProductStatus.InPreparation]: 'v príprave',
  [ProductStatus.Processing]: 'spracovávaný',
  [ProductStatus.Submitted]: 'odoslaný',
  [ProductStatus.WaitingForReview]: 'čaká na posúdenie',
  [ProductStatus.WaitingForSubmission]: 'čaká na odoslanie',
};

export const PRODUCT_STATUS_CHOICES = Object.entries(PRODUCT_STATUSES)
  .map(([id, name]) => ({ id, name }))
  .sort((a, b) => a.name.localeCompare(b.name));

export const PRODUCT_TYPES: Record<FinancialProductType, string> = {
  [FinancialProductType.BuildingSavings]: 'Stavebné sporenie',
  [FinancialProductType.CollisionInsurance]: 'Havarijné poistenie',
  [FinancialProductType.CreditCard]: 'Kreditná karta',
  [FinancialProductType.Generic]: 'Iný finančný produkt',
  [FinancialProductType.GenericInsurance]: 'Iné poistenie',
  [FinancialProductType.Investment]: 'Investičný produkt',
  [FinancialProductType.LifeInsurance]: 'Životné poistenie',
  [FinancialProductType.Loan]: 'Pôžička',
  [FinancialProductType.Mortgage]: 'Hypotéka',
  [FinancialProductType.MotorLiabilityInsurance]: 'PZP',
  [FinancialProductType.PropertyInsurance]: 'Poistenie majetku',
  [FinancialProductType.RetirementPensionSavings]: 'Starobné dôchodkové sporenie',
  [FinancialProductType.Savings]: 'Sporenie',
  [FinancialProductType.SupplementaryPensionSavings]: 'Doplnkové dôchodkové sporenie',
};

export const PRODUCT_TYPE_COLORS: Record<FinancialProductType, string> = {
  [FinancialProductType.BuildingSavings]: '#800000',
  [FinancialProductType.CollisionInsurance]: '#2196F3',
  [FinancialProductType.CreditCard]: '#4B0082',
  [FinancialProductType.Generic]: '#616161',
  [FinancialProductType.GenericInsurance]: '#006400',
  [FinancialProductType.Investment]: '#0D991C',
  [FinancialProductType.LifeInsurance]: '#EC983F',
  [FinancialProductType.Loan]: '#8B4513',
  [FinancialProductType.Mortgage]: '#ED4435',
  [FinancialProductType.MotorLiabilityInsurance]: '#E1498A',
  [FinancialProductType.PropertyInsurance]: '#FFC107',
  [FinancialProductType.RetirementPensionSavings]: '#483D8B',
  [FinancialProductType.Savings]: '#008B8B',
  [FinancialProductType.SupplementaryPensionSavings]: '#8B008B',
};
